<template>
  <div
    class="section-content pt-4"
    :class="{ 'mt-10': $vuetify.breakpoint.xs }"
  >
    <hb-header
      full
      :divider="false"
    >
      <hb-page-header
        title="Do Not Rent List"
        description="Store and Manage Company Level Contacts"
      >
      </hb-page-header>
    </hb-header>
    <hb-header
      fewer-actions
      :padding="false"
      align-top
      class="mt-n2"
      :divider="true"
    >
    </hb-header>
    <div style="flex: 1">
      <do-not-rent-contacts-list
        class="do-not-rent-table"
        :showCheckboxColumn="showCheckboxColumn"
        ref="doNotRent"
        @selected-rows="RowsSelectedChanged"
        @removeContact="openRemoveContact"
        @editContact="openEditContact"
        @addContact="openAddContact"
      />
    </div>

    <add-contact
      v-if="showAdd"
      :show="showAdd"
      :onClose="closeWindow"
      @saveContact="saveContact"
      :isEdit="isEdit"
      :editContact="editContact"
      :btnLoader="doNotRentLoader"
    />
    <remove-contact-modal
      v-if="showRemoveContact"
      :show="showRemoveContact"
      :onClose="closeRemoveWindow"
      :contactsList="contactsListToBeRemoved"
      @removeContact="removeContact"
      :btnLoader="removeBtnLoader"
    />

    <do-not-rent-modal
      v-model="showMatchFoundModal" 
      v-if="showMatchFoundModal"
      :contacts="contactsListToBeAdded"
      :loader="doNotRentLoader"
      @close="closeMatchFoundWindow"
      @process="addSelectedContacts"
      :btn-text="getBtnText"
      :confirmationText="dnrModelConformationText"
      :secondaryContent="dnrModelSecondaryContent"
      :title="dnrModelTitle"
      :allowMultiSelect="allowMultiSelect"
      :showProcessBtn="displayProcessButton"
      :showCloseBtn="displayCloseBtn"
      popupContext="dnr_tool"
      :primaryContent="dnrModelPrimaryContent"
      :newContact="saveNewContact ? contactInfo : {}"
    />
    <payments-notification-modal
      v-model="notificationModal"
      :notificationType="notificationModalType"
    />
  </div>
</template>

<script type="text/babel">
import api from "../../assets/api";
import Status from "../includes/Messages.vue";
import Loader from "../assets/CircleSpinner.vue";
import UploadList from "./modals/UploadList.vue";
import AddContact from "./modals/AddContact.vue";
import DoNotRentContactsList from "./DoNotRentContactsList.vue";
import RemoveContactModal from "./modals/RemoveContactModal.vue";
import DoNotRentModal from "../includes/DoNotRentModal.vue";
import { mapGetters } from "vuex";
import PaymentsNotificationModal from "../payments/PaymentsNotificationModal.vue";
import HbReport from "../assets/HummingbirdReportViewer.vue";
import FLAG_CHANGES_OBJECTS from "@/constants/flag_changes_objects.js";
import { EventBus } from "../../EventBus";
import { notificationMixin } from "../../mixins/notificationMixin.js";
import TENANT from '@/constants/tenant.js';


export default {
  name: "DoNotRent",
  mixins: [notificationMixin],
  components: {
    HbReport,
    Status,
    Loader,
    UploadList,
    AddContact,
    RemoveContactModal,
    PaymentsNotificationModal,
    DoNotRentContactsList,
    DoNotRentModal
  },
  mounted() {
    if (!this.hasPermission("view_do_not_rent_list"))
      this.$router.push("/dashboard");
  },
  data() {
    return {
      activeTab: "",
      showTabs: true,
      existingDoc: "",
      showUpload: false,
      attachments: [],
      showCheckboxColumn: false,
      selectDropdown: "allContacts",
      doNotRent: null,
      property_id: "",
      searchItems: [],
      contactsListToBeRemoved: [],
      searchField: "",
      showAdd: false,
      drawerHeight: "100%",
      showEdit: false,
      showRemoveContact: false,
      uploading: false,
      hideTableFilters: false,
      editContact: null,
      isEdit: false,
      notificationModal: false,
      notificationModalType: "",
      showMatchFoundModal: false,
      contactsListToBeAdded: [],
      contactInfo: null,
      isSoftMatch: false,
      isAlreadyExist: false,
      doNotRentLoader: false,
      removeBtnLoader: false,
      allowMultiSelect: false,
      saveNewContact: false,
    };
  },
  created() { 
    this.TENANT = TENANT;
  },
  computed: {
    ...mapGetters({
      hasPermission: "authenticationStore/rolePermission",
    }),
    actions_panel_list() {
      return ["export", "bulk_edit"];
    },
    dnrModelTitle() {
      const count = this.contactsListToBeAdded?.length > 1 ? ` (${this.contactsListToBeAdded.length})` : "";
      let match_text = this.$options.filters.pluralize('Match', count);
      let text = '';
      if (!this.contactsListToBeAdded?.length) {
        text = `Create new contact`;
      } else if (this.contactsListToBeAdded?.length && this.isAlreadyExist && !this.isSoftMatch) {
        text = `Contact Already Exist`;
      } else if (this.contactsListToBeAdded?.length > 0 && this.isSoftMatch) {
        text = `Soft ${match_text} Found${count}`;
      } else if (this.contactsListToBeAdded?.length > 0) {
        text = `Hard ${match_text} Found${count}`;
      }
      return text;
    },

    dnrModelConformationText() {
      return this.getDnrModelContent("CONFIRMATION_TEXT");
    },
    dnrModelPrimaryContent() {
      return this.saveNewContact ? this.getDnrModelContent("PRIMAY_CONTENT") : '';
    },
    dnrModelSecondaryContent() {
      return this.getDnrModelContent("SECONDARY_CONTENT");
    },
    displayProcessButton() {
      return this.isAlreadyExist && !this.isSoftMatch ? false : true;
    },
    getBtnText() {
      return this.isAlreadyExist && !this.isSoftMatch ? "Close" : "Add";
    },
    displayCloseBtn() {
      return this.isAlreadyExist && !this.isSoftMatch;
    }

  },
  methods: {
    onUploadClose() {
      this.showUpload = false;
    },
    closeWindow() {
      this.showAdd = false;
    },
    closeRemoveWindow() {
      this.showRemoveContact = false;
    },
    closeMatchFoundWindow() {
      this.showMatchFoundModal = false;
    },
    async saveContact(contact) {
      
      if (this.hasPermission("add_to_do_not_rent_list")) {
        this.doNotRentLoader = true;
          try {
            if(contact?.id) {
              let r = await api.post(this.$app, api.CONTACTS + `save-do-not-rent-contact`, contact);
              EventBus.$emit("doNotRentReportUpdated");
            } else {
              let r = await api.post(this.$app, api.CONTACTS + 'do-not-rent-list', { ...contact, fetch_non_dnrs: true});
              const resultArray = r;
              if(r){
                this.contactsListToBeAdded = resultArray;
                const isSoftMatch = resultArray.length ? resultArray.every(contact => contact.hard_match === 0) : false;
                this.allowMultiSelect = resultArray.length ? resultArray.every(contact => contact.hard_match === 0 && contact.is_dnr === 0) : false;
                const isAllDNR = resultArray.length ? resultArray.every(contact => contact.is_dnr === 1) : false;
                this.isSoftMatch = isSoftMatch;
                this.isAlreadyExist = isAllDNR;
                this.contactInfo = contact;
                if(this.isSoftMatch || this.contactsListToBeAdded.length === 0) {
                  this.saveNewContact = true;
                };
                console.log("contactInfo",this.contactInfo);
                this.showMatchFoundModal = true;
              }
            }
          } catch (error) {
            this.showMessageNotification({description: error.message}); //There is an error here lets fix that
          } finally {
            this.doNotRentLoader = false;
          }
      } else {
        this.showNotificationModal("add_to_do_not_rent_list");
      }     
      if(contact?.id) this.showMessageNotification({ type: 'success', description: `Do Not Rent List contact information has been updated.` })
      this.closeWindow();
    },
    getAttachments(attachments) {
      this.removeAttachment();
      this.attachments = attachments;
      this.onUploadClose();
    },
    removeAttachment() {
      this.attachments = [];
      this.existingDoc = "";
    },
    uploadDocumentAttachments(doc) {
      this.removeAttachment();
      this.existingDoc = doc;
      this.openUploadDocsStatus = false;
    },
    RowsSelectedChanged(rows) {
      this.contactsListToBeRemoved = rows;
    },
    openEditContact(contact) {
      if (!this.hasPermission("add_to_do_not_rent_list")) {
        this.showNotificationModal("add_to_do_not_rent_list");
        return;
      }
      this.isEdit = true;
      this.editContact = contact;
      this.showAdd = true;
    },
    openAddContact() {
      if (!this.hasPermission("add_to_do_not_rent_list")) {
        this.showNotificationModal("add_to_do_not_rent_list");
        return;
      }
      this.showAdd = true;
      this.isEdit = false;
    },
    async upload() {
      if (this.attachments.length) {
        let body = {
          document_type: this.type,
          document_type_id: this.document_type_id,
        };
        let response = await api.postFile(
          this,
          api.CONTACTS + this.contactId + "/upload",
          body,
          this.attachments
        );
        return response;
      } else {
        return {
          uploads: {
            id: this.existingDoc.id,
            mimetype: this.existingDoc.mimetype,
          },
        };
      }
    },
    openRemoveContact() {
      if (!this.hasPermission("remove_do_not_rent")) {
        this.showNotificationModal("remove_do_not_rent");
        return;
      }
      this.showRemoveContact = true;
    },
    getSuccessMsg(contact_count = 0, type = ''){
      let to_or_from = type === 'removed' ? 'from' : 'to';
      if(contact_count === 0) {
        return `No contact ${type} ${to_or_from} Do Not Rent List.`;
      }
      return `${contact_count} ${this.$options.filters.pluralize('Contact', contact_count)} ${this.$options.filters.pluralize('has', contact_count)} been successfully ${type} ${to_or_from} Do Not Rent List.`;
    },
    async removeContact(contact) {
      try {
        this.removeBtnLoader = true;
        const removedContactIds = contact.map((x) => ({
          id: x.tenant_id,
        }));
        const data = {
          flag_value: false,
          is_flag_value_changed: true,
          flag_object_ids: removedContactIds,
          flag_name: FLAG_CHANGES_OBJECTS.CONTACT_FLAGS.DO_NOT_RENT,
          context: 'remove_contact'
        };
        await api.post(
          this,
          api.FLAG_CHANGES_OBJECTS + "flag-type-bulk-update/contact",
          data
        );
        let successMsg = this.getSuccessMsg(removedContactIds.length, 'removed');
        this.showMessageNotification({
          type: "success",
          description: successMsg,
        });
        EventBus.$emit("doNotRentReportUpdated");
      } catch (error) {
        this.showMessageNotification({
          description: error,
        });
      } finally {
        this.removeBtnLoader = false;
      }
      this.closeRemoveWindow();
    },
    toggleCheckboxColumn() {
      this.showCheckboxColumn = !this.showCheckboxColumn;
      this.showEdit = this.showCheckboxColumn;
    },
    showNotificationModal(key) {
      this.notificationModalType = key;
      this.notificationModal = true;
    },
    changeContactsDropdown() {},
    editEvent() {
      this.toggleCheckboxColumn();
    },
    hideTableFiltersEvent(params) {
      this.hideTableFilters = params;
    },
    async addSelectedContacts(payload) {
      const { contactsToAdd } = payload;
      this.doNotRentLoader = true;

      try {
        //console.log("addContacts", contactsToAdd);

        const validContacts = contactsToAdd.filter(c => c?.id != null);
        const description = this.contactInfo.reason || this.contactInfo.description;

        // If there are valid existing contacts to flag
        if (validContacts.length) {
          const addContactIds = validContacts.map(({ id }) => ({ id }));
          console.log("addtoContacts", addContactIds);

          await api.post(
            this,
            `${api.FLAG_CHANGES_OBJECTS}flag-type-bulk-update/contact`,
            {
              flag_value: true,
              is_flag_value_changed: true,
              flag_object_ids: addContactIds,
              description,
              flag_name: FLAG_CHANGES_OBJECTS.CONTACT_FLAGS.DO_NOT_RENT,
              context: 'add_contact'
            }
          );
        }

        // If a new contact needs to be saved or no hard-match found or no soft-match selected
        if (validContacts.length === 0 || this.saveNewContact) {
          await api.post(this.$app, `${api.CONTACTS}save-do-not-rent-contact`, { ...this.contactInfo });
        }

        const totalAdded = (this.saveNewContact ? contactsToAdd.length + 1 : contactsToAdd.length) || 1;
        const successMsg = this.getSuccessMsg(totalAdded, 'added');

        this.showMessageNotification({
          type: "success",
          description: successMsg,
        });

        EventBus.$emit("doNotRentReportUpdated");
        this.closeMatchFoundWindow();

      } catch (error) {
        console.error(error);
        this.showMessageNotification({ description: error });
        //this.closeMatchFoundWindow();

      } finally {
        this.resetFlags();
        this.doNotRentLoader = false;
      }
    },
    getDnrModelContent(type) {
      const base = this.TENANT.DNR_MODEL.DNR_LIST;
      let text = '';
      if (!this.contactsListToBeAdded?.length) {
        text = base.NO_MATCH_FOUND[type];
      } else if (this.isAlreadyExist) {
        text = base.DNR_MATCH_FOUND[type];
      } else if (this.contactsListToBeAdded?.length > 0 && this.isSoftMatch) {
        text = base.NON_DNR_SOFT_MATCHS_FOUND[type];
      } else if (this.contactsListToBeAdded?.length > 0) {
        text = base.NON_DNR_HARD_MATCHS_FOUND[type];
      }
      return text;
    },
    resetFlags() {
      this.contactInfo = null;
      this.isSoftMatch = false;
      this.isAllDNR = false;
      this.saveNewContact = false;
      this.allowMultiSelect = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.inline-flex {
  display: inline-flex !important;
  float: left;
}

.flex-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.width-100 {
  width: 100%;
}

.side-bar-merch {
  border-left: 1px solid #ccc;
  width: 100%;
  height: 100%;
}

.lh-24px {
  line-height: 24px;
}
</style>

<style>
.w-126px .hb-secondary-button {
  width: 126px;
}
</style>
